module.exports = __webpack_public_path__ + "img/chinesecompany14.141a8fec.png";